<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des rapports</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="destinataires" slot-scope="props">{{ props.row.destinataires.split(';').join("\n") }}</div>
          <div slot="action" slot-scope="props">
            <span v-if="canAccess(rules.CAN_EDIT_REPORT)">
              <i class="fa fa-pencil mr-2 text-primary clickable" @click="voirRapport('edit', props.row.id)"></i>
            </span>
            <span v-if="canAccess(rules.CAN_DELETE_REPORT)">
              <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row.id)"></i>
            </span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button v-if="canAccess(rules.CAN_CREATE_REPORT)"
          type="button"
          @click="voirRapport('add')"
          class="pull-right"
          size="md"
          variant="primary">
          <i class="fa fa-plus"></i> Ajouter un rapport
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {rules, hasRule} from '../../../utils/rulesHelper'

  export default {
    data() {
      return {
        rules: rules,
        columns: ["libelle", "description", "destinataire_obligatoire", "destinataires", "action"],
        items: [],
        options: {
          headings: {
            libelle: "Libellé",
            description: "Description",
            destinataire_obligatoire: "Destinataire obligatoire",
            destinataires: "Destinataires",
            is_system: "Système"
          },
          columnsClasses: {
            libelle: 'pre-formatted sort-top position-r col-xs-8',
            description: 'pre-formatted sort-top position-r col-xs-6',
            destinataire_obligatoire: 'pre-formatted sort-top position-r col-xs',
            destinataires: 'pre-formatted sort-top position-r col-sm-4',
            is_system: 'pre-formatted sort-top position-r action-xs',
            action: 'pre-formatted sort-top position-r action-xs',
          },
          cellClasses:{
            libelle: [{
              class:'rapport-system',
              condition: row => row.is_system === true
            }]
          },
          sortable: ["libelle"],
          filterable: ["libelle"],
          perPage: 10,
          perPageValues: [10, 20, 25],
          texts: {filterPlaceholder: "Libellé"},
          orderBy: {column: "libelle", ascending: false},
        },
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all()
    },
    methods: {
      canAccess(rule) {
        return hasRule(rule)
      },
      all() {
        let self = this;
        this.$axios
          .get("/administration/rapports")
          .then(response => {
            this.items = response.data.rapports;
          })
          .catch(() => {
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Un probléme est survenu, merci de contacter l'administrateur",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer ce rapport ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("IS_LOADING", true);
              this.$axios
                .post("/administration/rapports/delete/" + id)
                .then(() => {
                  this.$store.commit("IS_LOADING", false);
                  this.$swal({
                    position: "top",
                    type: "success",
                    title: "Suppression avec succès",
                    text: "Le rapport a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  self.$store.commit("IS_LOADING", false);
                  self.$swal({
                    position: "top",
                    type: "warning",
                    title: "Attention !!",
                    text: "Un probléme est survenu, merci de contacter l'administrateur",
                    showConfirmButton: false,
                    timer: 5000
                  });
                });
            }
          });
      },
      voirRapport(to, id) {
        if (to === "add") {
          this.$router.push({path: "/administration/rapports/add"});
        } else if (to === "edit") {
          this.$router.push({path: "/administration/rapports/edit/" + id});
        }
      },
      returnBack() {
        this.$router.push({path: "/administration/rapports"});
      },
    }
  };
</script>

<style>
  .rapport-system {
    color: black;
    background-color: #eeddab;
  }
</style>